__webpack_require__.p = "/wp-content/plugins/darshboard-react-plugin/build/";